import React from 'react';
import {useAppStateContext} from '../../../providers/AppState';
import {useAccessRight} from '../../../controllers/useAccessRight';
import {
  PerformanceUnbilledReportTablePm,
  PerformanceUnbilledReportUnAssignedTable,
} from '../../pmt/views/PerformanceReportTable';
import {createMenuNavigator} from '../../../components/menu/MenuNavigator';
import {NewProjectUnbilledTab} from './NewProjectTab';

const ProjectGroup = createMenuNavigator();
export const ProjectUnbilledNavigatorPm = props => {
  const {
    route: {params},
  } = props;
  const {user, globalData: {accessRights: userAccessRights} = {}} =
    useAppStateContext();
  const {employee} = user;
  const canAccess = useAccessRight({accessRights: userAccessRights});
  return (
    <ProjectGroup.Navigator
      // canAccess={canAccess}
      data-navigator-id="ProjectGroup"
      {...props}>
      <ProjectGroup.Screen
        data-resource-id="ProjectBilledNew"
        name="New"
        props={{
          user: user,
          addOnParamFilter: {
            owner_id: employee?._id,
            project_status: 'a',
            projecttype: 'i',
          },
          tabName: 'unbilled',
          ...props,
        }}
        component={NewProjectUnbilledTab}
        options={{
          label: 'New',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectBilledUnassigned"
        name="Unassigned"
        component={PerformanceUnbilledReportUnAssignedTable}
        props={{
          filter: {
            project_status: 'a',
            projecttype: 'i',
            is_project_assign: {$in: [null, false]},
            owner_id: employee?._id,
          },
          user: user,
          tab: 'Unassigned',
          tabName: 'unbilled',
          ...props,
        }}
        options={{
          label: 'Unassigned(Active)',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectBilledAssigned"
        name="Assigned"
        component={PerformanceUnbilledReportTablePm}
        props={{
          filter: {
            project_status: 'a',
            projecttype: 'i',
            is_project_assign: true,
          },
          user: user,
          tab: 'Assigned',
          tabName: 'unbilled',
          ...props,
        }}
        options={{
          label: 'Assigned(Active)',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectHold"
        name="On-Hold"
        props={{
          project_status: 'h',
          projecttype: 'i',
          tab: 'On-hold',
          tabName: 'unbilled',
          ...props,
        }}
        component={PerformanceUnbilledReportTablePm}
        options={{
          label: 'On-Hold',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectCompleted"
        name="Completed"
        props={{
          project_status: 'c',
          projecttype: 'i',
          tab: 'Completed',
          tabName: 'unbilled',
          ...props,
        }}
        component={PerformanceUnbilledReportTablePm}
        options={{
          label: 'Closed',
        }}
      />
    </ProjectGroup.Navigator>
  );
};
